module.exports = __webpack_public_path__ + "img/layout_top_tree_left.f6754e75.svg";